import Vue from 'vue';
import Router from 'vue-router';

import ViewerMaster from '@/components/report_preview/ViewerMaster';
import FullView2021 from '@/components/report_preview/gri2021_viewer/FullView2021';
import FullView2021Micro from '@/components/report_preview/gri2021_viewer/FullView2021Micro';
import Error from '@/components/Error.vue';

const routes = [
  {
    path: '',
    component: ViewerMaster,
    children: [
      {
        path:
          process.env.VUE_APP_REPORT_CODE === undefined
            ? '/v'
            : process.env.VUE_APP_URL_NAME === undefined
            ? '/'
            : process.env.VUE_APP_URL_NAME,
        // 보고서가 /{연도} 경로(VUE_APP_URL_NAME)로 빌드된 경우, 도메인 루트(/)로
        // 들어와도(대표 보고서) 동일 화면이 보이도록 '/'를 alias로 추가한다.
        // CloudFront viewer-request 함수가 루트 요청에 /{연도}/index.html을 서빙하되
        // 브라우저 주소는 / 로 유지하므로, 라우터도 /를 매칭해야 한다.
        alias:
          process.env.VUE_APP_REPORT_CODE !== undefined &&
          process.env.VUE_APP_URL_NAME !== undefined
            ? '/'
            : undefined,
        name: 'ReportView',
        component: FullView2021,
        props: true
      },
      {
        path: '/micro',
        name: 'ReportViewMicro',
        component: FullView2021Micro,
        props: true
      }
    ],
    props: true
  },
  {
    path: '*',
    name: 'Error',
    component: Error
  }
];

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else return { x: 0, y: 0 };
  }
});

export default router;
